module.exports = __webpack_public_path__ + "media/images/iconBell__errorRed-a59c423bbc20735e1da5c32edfabaf09.png";